import PropTypes from 'prop-types';
import { MY_FORM_FIELDS } from './form-constants';

const formFieldsPropTypes = PropTypes.shape({
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(MY_FORM_FIELDS).isRequired,
  labelId: PropTypes.string,
  inputProps: PropTypes.objectOf(PropTypes.any),
});

export default formFieldsPropTypes;
